export const STORAGE = {
    USER: 'user',
    TOKEN: 'token',
    LOGGED_IN: 'logged_in',
    MAP_ZOOM: 'map_zoom',
    MAP_POS: 'map_pos',
    LANGUAGE: 'language',
};
